import normalize from 'json-api-normalizer';
import Section from './section.js';

export default class Forum {
	static from (jsonapi) {
		let key = 'forums'
		let normalizedJSONapi = normalize(jsonapi);
		if (!(Object.keys(normalizedJSONapi).includes(key))) return null;

		let keys = Object.keys(normalizedJSONapi[key]);
		if (keys.length > 0 && Array.isArray(jsonapi.data)) {
			let retVal = {};
			keys.forEach( function ( id ) {
				retVal[id] = Forum.make(normalizedJSONapi[key][id], normalizedJSONapi);
			});
			return retVal;
		} else return Forum.make(normalizedJSONapi[key][keys[0]], normalizedJSONapi);
	}

	static make(jsonapi, normalizedJSONapi) {
       const { id, attributes } = jsonapi;
       let sections = {};
       if ('relationships' in jsonapi && 'sections' in jsonapi['relationships']) {
           jsonapi.relationships.sections.data.forEach( function (rel) {
               sections[rel.id] = Section.make(normalizedJSONapi[rel.type][rel.id], normalizedJSONapi);;
           });
       }
       attributes['sections'] = sections;
		return new Forum ( Object.assign({id: id}, attributes) );
	}

	constructor ({ id, title, sectionsCount, sections }) {
		this.id           = id ? id : -1;
		this.title        = title ? title : null;
        this.sections		= sections ? sections : {};
		this.sections_count   = sectionsCount ? sectionsCount : null;
	}

}
